var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      ref: "tenancyHistoriesModal",
      attrs: {
        modalId: _vm.modalId,
        modalType: "large-modal",
        className: "tenancyHistoriesModal",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-header", attrs: { solt: "modal-header" } },
        [_vm._v("\n    " + _vm._s(_vm.$t("tenancy.changeHistory")) + "\n  ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "tenancy-histories__content",
          attrs: { slot: "content" },
          slot: "content",
        },
        [
          _c("UpdateHistories", {
            attrs: { rawHistories: _vm.parsedHistories },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }